<template>
    <BlockContainer
        :id="'article-hero-' + slugify(data.title)"
        :background-color="data.backgroundColor"
        :bottom-angle="data.bottomAngle"
        :angle-background-color="
            data.nextBackgroundColor ? data.nextBackgroundColor : null
        "
        :arrow-callout="data.arrowCallout"
        divider-arrow-class="left-8 md:bottom-10 xl:left-[65%] bottom-6 md:-bottom-2 lg:bottom-0 xl:bottom-10"
    >
        <div class="flex flex-col gap-x-20 py-16 md:flex-row lg:py-12">
            <div class="order-2 flex w-full items-center md:order-1 md:w-7/12">
                <StoryblokImage
                    v-if="data.image"
                    class="relative z-20 aspect-[4/3] w-full bg-transparent object-contain"
                    :src="data.image.src"
                    :alt="data.image.alt"
                    sizes="530px md:380px lg:680px xl:1030px"
                    :image-width="830"
                    :image-height="623"
                />
            </div>
            <div class="order-1 flex w-full items-center md:order-2 md:w-5/12">
                <div>
                    <TagGroup
                        v-if="tags.length"
                        :tags="tags"
                        class="mb-4"
                        color="grind"
                    />
                    <p class="mb-4">{{ data.date }}</p>
                    <h1 class="mb-4">{{ data.title }}</h1>
                    <WysiwygContent
                        :content="data.shortDescription"
                        class="mb-6"
                    />
                    <div
                        v-if="data.buttons"
                        class="mt-6 gap-x-2 md:mt-0 md:flex"
                    >
                        <Button
                            v-for="button in data.buttons"
                            :key="button._uid"
                            :button="button"
                            class="w-full md:w-auto"
                        />
                    </div>
                </div>
            </div>
        </div>
    </BlockContainer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { ArticleHeroType } from '#shared/types/ArticleHeroType';
import BlockContainer from '~/components/BlockContainer.vue';
import Button from '~/components/page-building/components/Button.vue';

const props = defineProps<{
    data: ArticleHeroType;
}>();

const tags = computed<string[]>(() => {
    return props.data.categories.map((category: string) => {
        return category.replace(/-/g, ' ');
    });
});
</script>
